import { FC } from "react";
import { ProgramExchangeDetailsType } from "src/Modules/PointsExchange/constants";
import { ExchangeDetailsCard, ExchangeModal, TermsBar } from "../components";
import ExchangeDetails from "../components/ExchangeDetails/ExchangeDetails";

const PointsExchangeMob: FC<ProgramExchangeDetailsType> = ({ termsAndConditions, loading, destinationProgram, exchangeInfo, requiredFields }) => {
  return (
    <div className="flex w-full flex-col gap-4 pb-40">
      <div className="rounded-xs outline-border-subtle flex flex-col gap-6 p-4 outline">
        <ExchangeDetailsCard destinationProgram={destinationProgram} exchangeInfo={exchangeInfo} />
        <ExchangeDetails loading={loading} exchangeInfo={exchangeInfo} destinationProgram={destinationProgram} requiredFields={requiredFields} />
      </div>
      <TermsBar terms={termsAndConditions} loading={loading} />
      <div className="shadow-bottom-sheet bg-background-default fixed end-0 start-0 bottom-0 z-50 rounded-t-xl p-4">
        <ExchangeModal destination={destinationProgram} exchangeInfo={exchangeInfo} termsAndConditions={termsAndConditions} />
      </div>
    </div>
  );
};

export default PointsExchangeMob;
